(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cascas-customer-portal"] && !Shopify.designMode) return;
  try {
    
  var portalOrigin = 'https://superagent.cascasoriginals.com';
  var portalLanguages = new WeakMap();
  var boundWeglot;
  function storefrontLanguage() {
    if (window.Weglot && window.Weglot.initialized && typeof window.Weglot.getCurrentLang === 'function') {
      return /^de(?:-|$)/i.test(window.Weglot.getCurrentLang()) ? 'de' : 'en';
    }
    return /^de(?:-|$)/i.test(document.documentElement.lang) || /^\/de(?:\/|$)/.test(window.location.pathname) ? 'de' : 'en';
  }
  function syncPortalLanguage(force) {
    var language = storefrontLanguage();
    document.querySelectorAll('.cascas-customer-portal__frame').forEach(function (frame) {
      if (new URL(frame.src).origin !== portalOrigin) return;
      if (force || portalLanguages.get(frame) !== language) {
        frame.contentWindow.postMessage({ type: 'cascas-customer-portal:language', language: language }, portalOrigin);
        portalLanguages.set(frame, language);
      }
    });
  }
  function connectStorefrontLanguage() {
    if (window.Weglot && typeof window.Weglot.on === 'function' && boundWeglot !== window.Weglot) {
      boundWeglot = window.Weglot;
      boundWeglot.on('initialized', function () { syncPortalLanguage(true); });
      boundWeglot.on('languageChanged', function () { syncPortalLanguage(false); });
    }
    syncPortalLanguage(false);
  }
  document.querySelectorAll('.cascas-customer-portal__frame').forEach(function (frame) {
    var url = new URL(frame.src);
    if (url.origin !== portalOrigin) return;
    url.searchParams.set('lang', storefrontLanguage());
    if (frame.src !== url.href) frame.src = url.href;
    frame.addEventListener('load', function () { syncPortalLanguage(true); });
  });
  new MutationObserver(connectStorefrontLanguage).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  // Weglot may initialize after the section script. Its script load and HTML language changes both reconnect it.
  document.addEventListener('load', connectStorefrontLanguage, true);
  window.addEventListener('load', connectStorefrontLanguage);
  connectStorefrontLanguage();
  window.addEventListener('message', function (event) {
    if (event.origin !== portalOrigin) return;
    var data = event.data;
    if (!data) return;
    document.querySelectorAll('.cascas-customer-portal__frame').forEach(function (frame) {
      if (frame.contentWindow !== event.source) return;
      if (data.type === 'cascas-customer-portal:ready') syncPortalLanguage(true);
      if (data.type === 'cascas-customer-portal:height' && Number.isSafeInteger(data.height) && data.height >= 320 && data.height <= 30000)
        frame.style.height = data.height + 'px';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const desktop = window.matchMedia('(min-width: 960px) and (hover: hover) and (pointer: fine)');
  const settleTimers = new WeakMap();

  document.addEventListener('wheel', event => {
    if (!desktop.matches || event.ctrlKey || event.defaultPrevented) return;
    if (!(event.target instanceof Element)) return;

    const carousel = event.target.closest('.featured-collection-slider__content');
    // Enable each homepage collection carousel independently.
    if (!carousel?.closest('[data-desktop-wheel]')) return;
    if (!carousel.classList.contains('visible')) return;

    const swiper = carousel.swiper;
    if (!swiper || swiper.destroyed || !swiper.enabled || swiper.isLocked) return;

    const horizontal = event.shiftKey && !event.deltaX ? event.deltaY : event.deltaX;
    if (!horizontal || (!event.shiftKey && Math.abs(horizontal) <= Math.abs(event.deltaY))) return;

    const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? carousel.clientWidth : 1;
    const delta = horizontal * unit * (swiper.rtlTranslate ? -1 : 1);
    const start = swiper.minTranslate();
    const end = swiper.maxTranslate();
    if (start === end) return;

    // Consume only horizontal gestures; vertical page scrolling stays native.
    event.preventDefault();
    clearTimeout(settleTimers.get(carousel));
    const position = Math.max(end, Math.min(start, swiper.getTranslate() - delta));
    swiper.setTransition(0);
    swiper.setTranslate(position);
    swiper.updateProgress(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    settleTimers.set(carousel, setTimeout(() => {
      settleTimers.delete(carousel);
      if (desktop.matches && carousel.isConnected && carousel.swiper === swiper && !swiper.destroyed) {
        swiper.slideToClosest(180);
      }
    }, 140));
  }, { passive: false });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const selector = '.collection-section .collection__products';
  const mobile = window.matchMedia('(max-width: 767px)');
  let pending = false;
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'characterData'
      ? record.target.parentElement?.closest('.product-item__product-title')
      : record.type === 'attributes'
        ? record.target.matches('.product-item, .collection__products')
        : record.target.closest?.(selector) || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
  });
  function watch() {
    observer.observe(document.getElementById('main'), {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class']});
  }
  function update() {
    pending = false;
    observer.disconnect();
    document.querySelectorAll(selector).forEach(grid => {
      grid.querySelectorAll('.cas-paired-title-break').forEach(span => span.classList.remove('cas-paired-title-break'));
      if (!mobile.matches || !grid.clientWidth) return;
      const cards = Array.from(grid.children).filter(card => card.matches('.product-item') && card.getClientRects().length);
      const rows = [];
      cards.forEach(card => {
        const rect = card.getBoundingClientRect();
        if (Math.abs(rect.width * 2 - grid.clientWidth) > 4) return;
        const link = card.querySelector('.product-item__product-title a');
        if (!link) return;
        const title = link.closest('.product-item__product-title');
        const lineHeight = parseFloat(getComputedStyle(title).lineHeight);
        const entry = {card, link, top: rect.top, lines: Math.round(title.getBoundingClientRect().height / lineHeight)};
        const row = rows.find(row => Math.abs(row[0].top - entry.top) < 2);
        if (row) row.push(entry); else rows.push([entry]);
      });
      rows.forEach(row => {
        if (row.length !== 2 || !row.some(item => item.lines > 1)) return;
        row.filter(item => item.lines === 1).forEach(({link}) => {
          let lastWord = link.querySelector('[data-cas-last-word]');
          if (!lastWord) {
            if (link.children.length) return;
            const match = link.textContent.match(/^(.*\S)(\s+)(\S+)\s*$/s);
            if (!match) return;
            lastWord = document.createElement('span');
            lastWord.setAttribute('data-cas-last-word', '');
            lastWord.textContent = match[3];
            link.replaceChildren(document.createTextNode(match[1] + match[2]), lastWord);
          }
          lastWord.classList.add('cas-paired-title-break');
        });
      });
    });
    watch();
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  function start() {
    if (!document.getElementById('main')) return;
    watch();
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.fonts?.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();

  } catch(e) { console.error(e); }
})();
})();
